import type { ClearinghouseState, UserFills } from '@/lib/utils/hyper/types';

import { ChartInterval, PositionDetailChart } from './PositionDetailChart';
import { Box } from '@chakra-ui/react';
import PriceDisplay from '../trade/TradeHeader/PriceDisplay';
import { formatPriceDisplay } from '@/lib/utils/format';
import { UserProfileSection } from './UserProfileSection';
import { PositionDetailCard } from './PositionDetailCard';
import { useState } from 'react';

interface PositionDetailHeaderProps {
  position: ClearinghouseState['assetPositions'][0]['position'];
  userAddress: string;
  userData: { name?: string; avatar?: string } | null;
  priceDisplayData: {
    price: number;
    changePercent: string;
    isPositive: boolean;
  };
  filteredFills?: UserFills;
  handleAvatarPress?: () => void;
}

export function PositionDetailHeader({
  position,
  userAddress,
  userData,
  priceDisplayData,
  filteredFills,
  handleAvatarPress,
}: PositionDetailHeaderProps) {
  // 图表间隔状态管理
  const [chartInterval, setChartInterval] = useState<ChartInterval>('1h');
  
  return (
    <Box>
      {/* Price Display */}
      <Box px={4} py={2}>
        <PriceDisplay
          price={formatPriceDisplay(priceDisplayData.price)}
          changePercent={priceDisplayData.changePercent}
          isPositive={priceDisplayData.isPositive}
          hideExpandIcon={true}
        />
      </Box>

      {/* User Profile Section */}
      <Box mb={4} onClick={handleAvatarPress}>
        <UserProfileSection
          userAddress={userAddress}
          userName={userData?.name}
          avatarUrl={userData?.avatar}
        />
      </Box>

      {/* Position Detail Chart */}
      <PositionDetailChart
        position={position}
        filteredFills={filteredFills}
        coinSymbol={position?.coin}
        interval={chartInterval}
        onIntervalChange={setChartInterval}
      />

      {/* Position Detail Card */}
      <Box py={4}>
        <PositionDetailCard position={position} />
      </Box>
    </Box>
  );
}
